export function InicioDia(fecha) {
    const fechaFinDia = new Date(fecha).setHours(0,0,0,0)
    return (
        new Date(fechaFinDia)
    )
}